import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_ctx.ready)
    ? (_openBlock(), _createBlock(_component_v_tooltip, {
        key: 0,
        text: _ctx._tooltip,
        disabled: _ctx._tooltip === '',
        location: "top",
        size: "x-small"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            density: "compact",
            color: _ctx._color,
            type: _ctx._type,
            disabled: _ctx._disabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx._click(_ctx.value))),
            class: _ctx._buttonClass,
            variant: "text"
          }), {
            default: _withCtx(() => [
              (_ctx.icon != null)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: _ctx.icon,
                    class: _normalizeClass(_ctx._iconClass),
                    size: _ctx._size
                  }, null, 8, ["icon", "class", "size"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.label), 1))
            ]),
            _: 2
          }, 1040, ["color", "type", "disabled", "class"])
        ]),
        _: 1
      }, 8, ["text", "disabled"]))
    : _createCommentVNode("", true)
}